import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './LoadingCover.sass';

// fixed pins the cover to the viewport, for pages whose content grows taller
// than the positioned ancestor the default absolute cover sizes against
const LoadingCover = ({ fixed = false }) => (
	<div className={'ts-loading-shading-mui' + (fixed ? ' ts-loading-shading-fixed' : '')}>
		<CircularProgress className="ts-loading-icon-mui" />
	</div>
);

export default LoadingCover;
